import { forwardRef } from 'react';
import MenuItem, { MenuItemProps } from '@mui/material/MenuItem';
import clsx from 'clsx';

export interface ControllerMenuItemProps extends MenuItemProps {
  color?: 'primary' | 'secondary';
}

export const ControllerMenuItem = forwardRef<HTMLLIElement, ControllerMenuItemProps>(function (
  { classes, color = 'primary', ...other }: ControllerMenuItemProps,
  ref
) {
  const { root, ...otherClasses } = classes || {};

  return (
    <MenuItem
      {...other}
      classes={{
        root: clsx(color === 'secondary' && 'MasonMenuItem-secondary', root),
        ...otherClasses,
      }}
      ref={ref}
    />
  );
});

ControllerMenuItem.displayName = 'ControllerMenuItem';
